import {bindLoading} from './index';
import {ManageService} from '../services';

export default {
    namespaced: true,
    state: {
        forms: [],
        bookingParams: undefined
    },

    mutations: {
        saveForms(current, forms) {
            current.forms.splice(0);
            current.forms = forms;
        },
        toBookingPage(current, bookingParams){
            current.bookingParams = {...bookingParams};
        }
    },
    actions: {
        // async submitSuperFormAction({dispatch, commit}, formData) {
        //     return await bindLoading(commit, async () => {
        //         return await BookingService.submitSuperForm(formData);
        //     }, 'manage')
        // },
        async getFormsAction({commit}) {
            await bindLoading(commit, async () => commit('saveForms', await ManageService.getForms()), 'manage')
        },

        async deleteFormAction({commit, state}, id) {
            return await bindLoading(commit, async () => {

                const result = await ManageService.deleteForm(id);

                if (result.success) {
                    const forms = [...state.forms.filter(r => r.id !== id)];
                    commit('saveForms', forms);
                }
                return result;
            }, 'manage');

        },

        async cancelEventAction({commit, state}, id) {
            return await bindLoading(commit, async () => {
                const result = await ManageService.cancelEvent(id);
                if (result.success) {
                    const ownForm = state.forms.find(f => f.periods.some(p => p.id === id));
                    if(ownForm){
                        const newForm = {...ownForm,
                            periods: [
                                ...ownForm.periods.filter(p => p.id !== id),
                                ...ownForm.periods.filter(p => p.id === id)
                                    .map(p => ({...p, cancelable: false}))
                            ]
                        };
                        const forms = [
                            ...state.forms.filter(r => r.id !== ownForm.id),
                            newForm,
                        ];
                        commit('saveForms', forms);
                    }
                }
                return result;
            }, 'manage');

        }
    }
}